import {
  BlockObject,
  Configs,
  ContentModelConfigMergedBase,
  getContentViewFunction,
  getPreviewLinkFunction,
} from '@dudagroup/editor'
import {ContentEditAction} from '@dudagroup/editor/lib/client/control/contentReducer'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {Grid, Panel, Message} from 'rsuite'
import {BlockList} from './atoms/blockList'

export const getGenericViewWithCustomBlockList: getContentViewFunction = (
  content: any,
  handleChange: any,
  disabled: boolean,
  dispatch: React.Dispatch<ContentEditAction>,
  configs: Configs,
  contentModelConfigMerged: ContentModelConfigMergedBase,
  langLaneL,
  langLaneR,
  langUi
) => {
  return (
    <GenericViewWithBlockList
      {...{
        content,
        handleChange,
        disabled,
        dispatch,
        configs,
        contentModelConfigMerged,
        langLaneL,
        langLaneR,
        langUi,
      }}></GenericViewWithBlockList>
  )
}

interface GenericViewWithBlockListProps {
  content: any
  handleChange: any
  disabled: boolean
  dispatch: React.Dispatch<ContentEditAction>
  configs: Configs
  contentModelConfigMerged: ContentModelConfigMergedBase
  langLaneL: string
  langLaneR: string
  langUi: string
}

function GenericViewWithBlockList(props: GenericViewWithBlockListProps) {
  const {
    content,
    handleChange,
    disabled,
    dispatch,
    configs,
    contentModelConfigMerged,
    langLaneL,
    langLaneR,
    langUi,
  } = props
  const {blocks, ...rest} = contentModelConfigMerged.schema.content
  const {t} = useTranslation()
  return (
    <Grid>
      <Panel
        collapsible
        defaultExpanded
        header={<div style={{fontWeight: 'bold'}}>{t('content.panels.contentSectionTitle')}</div>}
        bordered
        style={{
          overflow: 'visible',
        }}>
        <BlockObject
          model={{
            type: 'object' as any,
            fields: rest,
          }}
          value={content}
          schemaPath={[]}
          configs={configs}
          dispatch={dispatch}
          languageContext={{
            langLane1: langLaneL,
            langLane2: langLaneR,
            languagesConfig: configs.apiConfig.languages,
            langUi: langUi,
          }}></BlockObject>
      </Panel>
      <div
        style={{
          marginTop: '20px',
          marginBottom: '45px',
          borderRadius: 6,
          paddingTop: 10,
          paddingRight: 20,
          paddingBottom: 10,
          paddingLeft: 20,
          boxSizing: 'border-box',
          gap: 5,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          display: 'flex',
          justifyContent: 'center',
          background: '#c7e5fc',
        }}>
        {<strong style={{color: '#575757'}}>{t('blockList.contentBlocks')}</strong>}
      </div>
      <BlockList
        value={content}
        disabled={disabled}
        dispatch={dispatch}
        configs={configs}
        blockCases={contentModelConfigMerged.schema.content.blocks.contentType.cases}
        languageLaneL={langLaneL}
        languageLaneR={langLaneR}
        langUi={langUi}></BlockList>
    </Grid>
  )
}

export const getPreviewLink: getPreviewLinkFunction = (token, language, recordData) => {
  const settings = document.getElementById('settings')

  if (settings?.textContent) {
    const {websiteUrl, apiURL} = JSON.parse(settings.textContent)

    const base64WebsiteUrl = btoa(websiteUrl)
    const base64ApiUrl = btoa(apiURL)

    const previewUrl = new URL('/api/preview', websiteUrl)
    previewUrl.searchParams.set('preview', 'true')
    previewUrl.searchParams.set('lang', language)
    previewUrl.searchParams.set('contentType', recordData.contentType)
    previewUrl.searchParams.set('id', recordData.id)
    previewUrl.searchParams.set('slug', recordData.slugI18n[language])
    previewUrl.searchParams.set('revision', recordData.revision.toString())
    previewUrl.searchParams.set('token', token)
    previewUrl.searchParams.set('apiURL', base64ApiUrl)
    previewUrl.searchParams.set('websiteUrl', base64WebsiteUrl)

    return previewUrl.toString()
  }

  throw new Error('Unable to create preview link: missing website settings')
}
